__turbopack_context__.v({
  "dragHandle": "CategoryGridItem-module-scss-module__WJknbG__dragHandle",
  "hover": "CategoryGridItem-module-scss-module__WJknbG__hover",
  "item": "CategoryGridItem-module-scss-module__WJknbG__item",
  "selected": "CategoryGridItem-module-scss-module__WJknbG__selected",
});
